enum TopicTypes {
  GAUGE = "gauge",
  TEXT = "text",
  HIDDEN = "hidden",
  REASON = "reason",
  PROGRESS = "progress",
  ALARM = "alarm",
}
export default TopicTypes;
